import React, { useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  Alert,
  IconButton,
  InputAdornment,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../routes/paths";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import AuthLayout from "./authLayout";

const AuthPasswordCreate: React.FC = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isError, setIsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (password !== confirmPassword) {
      setIsError(true);
    } else {
      setIsError(false);
      navigate(PATHS.AUTH_SIGN_IN);
    }
  };

  return (
    <AuthLayout >
      <Card
        elevation={3}
        sx={{
          margin: "auto",
          padding: 3,
          display: "flex",
          flexDirection: "column",
          maxWidth: "450px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            bgcolor: "#EDF7EC",
            color: "#305633",
            px: 2,
            py: 1,
            borderRadius: 1,
            gap: 1,
            marginBottom: 2,
          }}
        >
          <CelebrationOutlinedIcon sx={{ color: "#4CAF50" }} />
          <Box>
            <Typography variant="body1" sx={{ color: "#305633" }}>
              LEAPLEへようこそ！
            </Typography>
            <Typography variant="body2" sx={{ color: "#305633", mt: 1 }}>
              パスワードを設定してください
            </Typography>
          </Box>
        </Box>
        {isError && <Alert severity="error">パスワードが異なります。</Alert>}
        <form onSubmit={handleSubmit}>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              type={showPassword ? "text" : "password"}
              fullWidth
              onChange={(e) => setPassword(e.target.value)}
              label="パスワード"
              value={password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              type={showConfirmPassword ? "text" : "password"}
              fullWidth
              onChange={(e) => setConfirmPassword(e.target.value)}
              label="パスワード(確認用)"
              value={confirmPassword}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={toggleConfirmPasswordVisibility}
                      edge="end"
                    >
                      {showConfirmPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button sx={{ height: "42px" }} type="submit" variant="contained" fullWidth>
              登録
            </Button>
          </Box>
        </form>
      </Card>
    </AuthLayout>
  );
};

export default AuthPasswordCreate;
